import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from './icons/Icons';
import EllipseButton from './EllipseButton';
import NumberButton from './NumberButton';

const propTypes = {
    pages: PropTypes.number,
    activePage: PropTypes.number,
    margin: PropTypes.number,
    wings: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string
};

const defaultProps = {
    pages: 1,
    activePage: 0,
    margin: 1,
    wings: 1,
    ariaLabel: 'Page navigation'
};

export default class Pagination extends React.Component {
    constructor(props) {
        super(props);

        this.generateButtons = this.generateButtons.bind(this);
        this.buttonRange = this.buttonRange.bind(this);
    }

    buttonRange(high, low) {
        return ([...Array(high - low).keys()].map((v) => v + low).map((i) => (
            <NumberButton
                key={`NumberButton-${i}`}
                index={i}
                active={i === this.props.activePage}
                onClick={this.props.onChange} />
        )));
    }

    generateButtons() {
        const lowRange = {
            low: 0,
            high: 0 + this.props.margin
        };

        const activeRange = {
            low: this.props.activePage - this.props.wings,
            high: this.props.activePage + this.props.wings + 1
        };

        const highRange = {
            low: this.props.pages - this.props.margin,
            high: this.props.pages
        };

        const midRange = {
            low: activeRange.low > lowRange.high ? activeRange.low : lowRange.low,
            high: activeRange.high < highRange.low ? activeRange.high : highRange.high
        };

        const buttons = [];
        if (midRange.low > lowRange.low) {
            buttons.push(this.buttonRange(lowRange.high, lowRange.low));
            buttons.push(
                <EllipseButton key="low-ellipse" />
            );
        }

        buttons.push(this.buttonRange(midRange.high, midRange.low));

        if (midRange.high < highRange.high) {
            buttons.push(
                <EllipseButton key="high-ellipse" />
            );
            buttons.push(this.buttonRange(highRange.high, highRange.low));
        }

        return buttons;
    }

    render() {
        const disablePrevious = this.props.activePage === 0 ? 'rec-disabled-button' : '';
        const disableNext = this.props.activePage === this.props.pages - 1 ? 'rec-disabled-button' : '';
        const nextPage = this.props.activePage < this.props.pages - 1 ? this.props.activePage + 1 : this.props.activePage;
        const previousPage = this.props.activePage > 0 ? this.props.activePage - 1 : this.props.activePage;

        const pageButtons = this.generateButtons();

        return (

            <nav aria-label={this.props.ariaLabel}>
                <ul className="rec-pagination">
                    <li>
                        <button
                            disabled={this.props.activePage === 0}
                            aria-label="Previous Page"
                            className={disablePrevious}
                            onClick={() => this.props.onChange(previousPage)}>
                            <Icons.IconArrowBack />
                        </button>
                    </li>
                    {pageButtons}
                    <li>
                        <button
                            disabled={this.props.activePage === this.props.pages - 1}
                            aria-label="Next Page"
                            className={disableNext}
                            onClick={() => this.props.onChange(nextPage)}>
                            <Icons.IconArrowForward />
                        </button>
                    </li>
                </ul>
            </nav>

        );
    }
}

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;
